import axios from 'axios'
import storage from '../utils/session-storage'
import { debounce } from '../utils/debounce'

class NoteHolder extends HTMLElement {
  constructor() {
    super()
    const storedNote = storage.getItem('note')
    const noteElement = this.querySelector('textarea')

    /**
     * Initial stored Note check.
     */
    if (storedNote) {
      noteElement.value = storedNote
    }

    /**
     * Check if has initial value.
     */
    if (noteElement.value.length > 0) {
      this.classList.add('js-has-value')
    }

    /**
     * Update cart note.
     *
     * @param {string} value
     */
    const updateCartNote = (value) => {
      const method = 'POST'
      const url = window.routes.cart_update_url
      const body = JSON.stringify({ note: value })

      try {
        axios({
          method,
          url: url,
          headers: {
            'Content-Type': 'application/json',
            Accept: `application/json`,
          },
          data: body,
        })
      } catch (error) {
        // Check if the error is related to all the available items being in the cart.
      }
    }

    /**
     * Add event listener for input change.
     *
     * With an debounce to prevent an overflow of requests.
     */
    noteElement.addEventListener(
      'input',
      debounce((event) => {
        // If the target has no value
        if (event.target.value.length === 0) {
          storage.removeItem('note')
          this.classList.remove('js-has-value')
        }

        // If the target has a value
        updateCartNote(event.target.value)
        storage.setItem('note', noteElement.value)
      }, 300)
    )
  }
}

// Check if element is defined, if not define it..
if (customElements.get('note-holder') === undefined) {
  customElements.define('note-holder', NoteHolder)
}
